import { AfterContentChecked, ChangeDetectorRef, Component, Input } from '@angular/core';
import { SidenavEnum } from '../../admin/sidenav.enum';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { AuthService, UserService as AuthUserService } from '@core/auth';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ConfirmationDialogService } from '@ui/confirmation-dialog';
import { I18n } from '@ngx-translate/i18n-polyfill';

const LOGIN_URL = environment.loginUrl;

@Component({
  selector: 'cabinet-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements AfterContentChecked {

  isSmallScreen: boolean;

  @Input() links = [];

  constructor(
    public breakpointObserver: BreakpointObserver,
    private confirmationDialogService: ConfirmationDialogService,
    private router: Router,
    public authUserService: AuthUserService,
    private authService: AuthService,
    private i18n: I18n,
    private cdr: ChangeDetectorRef,
  ) {
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(state => {
      this.isSmallScreen = state.matches;
    });
  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
  logout() {
    this.confirmationDialogService.confirm({
      cancelBtnText: this.i18n('Отмена'),
      confirmBtnText: this.i18n('Выйти'),
      message: this.i18n('Вы действительно хотите выйти?'),
      title: this.i18n('Выход')
    })
      .then(() => {
        this.authService.logout()
          .pipe(finalize(() => {
            this.router.navigate([LOGIN_URL]);
          }))
          .subscribe();
      })
      .catch(() => { });
  }
}
